import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export function Breadcrumbs() {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    if (location.pathname === "/") return null;

    return (
        <nav aria-label="Breadcrumb" className="bg-slate-50 border-b border-slate-200/50 py-3 font-sans">
            <ol className="max-w-7xl mx-auto px-4 flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-slate-400">
                <li>
                    <Link to="/" className="hover:text-blue-600 flex items-center gap-1 transition-colors">
                        <Home className="w-3 h-3" />
                        <span>Home</span>
                    </Link>
                </li>

                {pathnames.map((name, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const isLast = index === pathnames.length - 1;

                    // Format names (e.g., cookie-policy -> Cookie Policy)
                    const displayName = name.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

                    return (
                        <li key={name} className="flex items-center gap-2">
                            <ChevronRight className="w-3 h-3 text-slate-300" aria-hidden="true" />
                            {isLast ? (
                                <span aria-current="page" className="text-slate-900">{displayName}</span>
                            ) : (
                                <Link to={routeTo} className="hover:text-blue-600 transition-colors">
                                    {displayName}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
